import React from 'react';
import { formatDateTime } from '../../../../utils';

import './index.scss';

const EventDate = ({ fullDate, day, color }) => {
  return (
    <time dateTime={formatDateTime(fullDate)} className={`event-date secondary-${color}`}>
      <span className="day">{day}</span>
    </time>
  );
};

export default EventDate;
